// Initialize concept galleries
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.unebi-concept-gallery').forEach(gallery => {
    const mainImages = gallery.querySelectorAll('.unebi-concept-gallery__main-item');
    const thumbnails = gallery.querySelectorAll('.unebi-concept-gallery__thumbnail');
    const thumbnailsContainer = gallery.querySelector('.unebi-concept-gallery__thumbnails');
    
    // Add class based on number of thumbnails for dynamic width calculation
    if (thumbnailsContainer && thumbnails.length > 0) {
      thumbnailsContainer.classList.add(`thumbnails-count-${thumbnails.length}`);
    }
    
    if (thumbnails.length === 0) return;
    
    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', (event) => {
        const targetId = event.currentTarget.dataset.target;
        
        // Update main image
        mainImages.forEach(img => {
          if (img.dataset.imageId === targetId) {
            img.classList.add('is-active');
          } else {
            img.classList.remove('is-active');
          }
        });
        
        // Update thumbnails
        thumbnails.forEach(thumb => {
          if (thumb.dataset.target === targetId) {
            thumb.classList.add('is-active');
          } else {
            thumb.classList.remove('is-active');
          }
        });
      });
    });
  });
});

